import { type Brick } from 'brs-js';
import { brickSizeMap } from './constants';

// get brick size for special bricks
export function getBrickSize(brick: Brick, brick_assets: string[]) {
  const asset =
    brick.asset_name_index != null
      ? brick_assets[brick.asset_name_index]
      : undefined;
  return (asset != null ? brickSizeMap[asset] : undefined) || brick.size;
}
export default getBrickSize;
